import classnames from "classnames";
import {Col, Nav, NavItem, NavLink, Row} from "reactstrap";
import React from "react";
import PropTypes from "prop-types";
import "./index.css"

const ViewerProfileTabComponent = (props) => {

    const purchasedContentClassNames = classnames({
        active: props.activeTab === "purchased",
        "cursor-pointer": true
    });

    const subscribedContentClassNames = classnames({
        active: props.activeTab === "subscribed",
        "cursor-pointer": true
    });

    const subscriptionsContentClassNames = classnames({
        active: props.activeTab === "subscriptions",
        "cursor-pointer": true
    });

    const followingContentClassNames = classnames({
        active: props.activeTab === "following",
        "cursor-pointer": true
    });

    const aboutClassNames = classnames({
        active: props.activeTab === "viewer_about",
        "cursor-pointer": true
    });

    return (
        <Row className={"profile-tab-component-container"}>
            <Col md="12">
                <Nav tabs className="availability-requests">
                    {
                        !props.isForOther &&
                        <NavItem className="ml-md-3">
                            <NavLink
                                className={purchasedContentClassNames}
                                onClick={() => props.toggle("purchased")}>
                                PURCHASED
                            </NavLink>
                        </NavItem>
                    }
                    {
                        !props.isForOther &&
                        <NavItem className="ml-md-3">
                            <NavLink
                                className={subscribedContentClassNames}
                                onClick={() => props.toggle("subscribed")}>
                                SUBSCRIBED
                            </NavLink>
                        </NavItem>
                    }
                    {
                        !props.isForOther &&
                        <NavItem className="ml-md-3">
                            <NavLink
                                className={subscriptionsContentClassNames}
                                onClick={() => props.toggle("subscriptions")}>
                                SUBSCRIPTIONS
                            </NavLink>
                        </NavItem>
                    }

                    <NavItem className="ml-md-3">
                        <NavLink
                            className={followingContentClassNames}
                            onClick={() => props.toggle("following")}>
                            FOLLOWING
                        </NavLink>
                    </NavItem>


                    {
                        !props.isForOther &&
                        <NavItem className="ml-md-3">
                            <NavLink
                                className={aboutClassNames}
                                onClick={() => props.toggle("viewer_about")}>
                                ABOUT
                            </NavLink>
                        </NavItem>
                    }
                </Nav>
            </Col>
        </Row>
    )
};

ViewerProfileTabComponent.propTypes = {
    activeTab: PropTypes.string.isRequired,
    toggle: PropTypes.func.isRequired,
};


export default ViewerProfileTabComponent;